<template>
  <b-tab>
    <template #title>
      <span class="d-none d-sm-inline">Delay Discounts</span>
    </template>
    <b-container>
      <div class="mb-2 d-flex justify-content-between align-items-center">
        <b-button
          variant="success"
          @click="validateForm"
        >
          Save Delay Discounts Changes
        </b-button>
        <b-button
          variant="primary"
          class="mb-2"
          @click="addNewDiscount"
        >
          <span>Add new delay discount</span>

        </b-button>
      </div>

      <validation-observer
        v-for="(el, index) in delayDiscounts"
        :key="el.localId"
        :ref="`delayDiscountRef-${el.localId}`"
      >
        <b-form>
          <b-row
            class="pb-5 delays_form_style"
          >
            <b-col
              md="12"
              class="d-flex justify-content-end"
            >
              <b-button
                variant="flat"
                @click="deleteDiscountForm(index)"
              >
                <feather-icon
                  icon="Trash2Icon"
                  size="25"
                  style="color: #CE224D"
                />
              </b-button>
            </b-col>
            <b-col
              md="4"
              class="pt-1"
            >
              <validation-provider
                name="from"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="From"
                  :label-for="`from${el.localId}`"
                >
                  <b-form-input
                    :id="`from${el.localId}`"
                    v-model="el.from"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              md="4"
              class="pt-1"
            >
              <validation-provider
                name="to"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="To"
                  :label-for="`to${el.localId}`"
                >
                  <b-form-input
                    :id="`to${el.localId}`"
                    v-model="el.to"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              md="4"
              class="pt-1"
            >
              <validation-provider
                name="code"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Code"
                  :label-for="`code${el.localId}`"
                >
                  <b-form-input
                    :id="`code${el.localId}`"
                    v-model="el.code"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <hr>
          </b-row>
        </b-form>
      </validation-observer>
    </b-container>

  </b-tab>
</template>

<script>
import {
  BTab, BContainer, BRow, BCol, BFormInput, BButton, BForm, BFormGroup,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import { tripStates, operators } from '../../hooks/useStaticOptions'
import { errorNotification } from '@/utils/toast-notifications'
import useValidateDynamicForm from '../../hooks/use-validate-dynamic-forms'

export default {
  components: {
    BTab,
    BContainer,
    BRow,
    BCol,
    BFormInput,
    BButton,
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
  },
  props: {
    delayDiscount: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const delayDiscounts = ref(props.delayDiscount.map(el => ({ ...el, localId: Math.random().toString() })))

    const addNewDiscount = () => {
      const temp = {
        localId: Math.random().toString(),
        from: null,
        to: null,
        code: null,
      }
      delayDiscounts.value.unshift(temp)
    }
    const deleteDiscountForm = index => {
      delayDiscounts.value.splice(index, 1)
    }

    const validateForm = async () => {
      const isValid = await useValidateDynamicForm(ctx)
      if (isValid) {
        ctx.emit('delay-discount-set', delayDiscounts.value)
        ctx.emit('apply-discount')
      } else {
        errorNotification('Fill out the required fields')
      }
    }

    return {
      required,
      tripStates,
      operators,
      validateForm,
      addNewDiscount,
      deleteDiscountForm,
      delayDiscounts,
    }
  },
}
</script>

<style scoped>
  .delays_form_style{
      border: 3px solid lightgray;
      padding: 20px;
      margin-bottom: 30px;
      border-radius: 20px;
  }
</style>
